// Molecules - Combinations of atoms
import { Platform } from 'react-native';
import { PaymentItemMobile } from './PaymentItem';
import { PaymentItemWeb } from './PaymentItemWeb';
export { Accordion } from './Accordion';
export type { AccordionProps } from './Accordion';
export { WebAccordion } from './WebAccordion';
export type {
  WebAccordionProps,
  WebAccordionVariant,
} from './WebAccordion';
export { CardCarousel } from './CardCarousel';
export type { CardCarouselProps } from './CardCarousel';
export { Collapsible } from './Collapsible';
export { BottomSheet } from './BottomSheet';
export { DashedDivider } from './DashedDivider';
export type { DashedDividerProps } from './DashedDivider';
export { DocumentItem } from './DocumentItem';
export { OwnerItem } from './OwnerItem';
export { default as ProfileNotificationHeader } from './ProfileNotificationHeader';
export { Toast } from './Toast';
export type { ToastProps, ToastPosition } from './Toast';

// New Figma-based molecules (explicit re-exports to avoid casing conflicts on some platforms)
export { ChequeItem } from './ChequeItem';
export { BaseHeader } from './header/BaseHeader';
export { LogoHeader } from './header/LogoHeader';
export { ProgressHeader } from './header/ProgressHeader';
export { TextHeader } from './header/TextHeader';
export { ImageCarousel } from './ImageCarousel';
export { LastPaymentItem } from './LastPaymentItem';
export { NoteBanner } from './NoteBanner';
export type { NoteBannerProps, NoteBannerVariant } from './NoteBanner';
export { NotificationCard } from './NotificationCard';
export type { NotificationCardProps } from './NotificationCard';
export { NumberPad } from './NumberPad';
export { OTPInput } from './OTPInput';
export { PasscodeBoxes } from './PasscodeBoxes';
export { PasscodeDisplay } from './PasscodeDisplay';

export const PaymentItem =
  Platform.OS === 'web' ? PaymentItemWeb : PaymentItemMobile;
export { PaymentItemWeb };
export { PaymentsEmptyState } from './PaymentsEmptyState';
export { PaymentSummaryCard } from './PaymentSummaryCard';
export { PropertyCard } from './PropertyCard';
export { AdhaUnitStatusBadge } from './AdhaUnitStatusBadge';
export type { AdhaUnitStatusBadgeProps } from './AdhaUnitStatusBadge';

// Skeleton components
export { QuickLinksSection } from './QuickLinksSection';
export * from './skeleton';
export { WelcomeCard } from './WelcomeCard';

// Dialogs
export { AppointmentActionsPopup } from './dialogs/AppointmentActionsPopup';
export type { AppointmentActionsPopupProps } from './dialogs/AppointmentActionsPopup';
export { AppointmentConfirmedDialog } from './dialogs/AppointmentConfirmedDialog';
export type { AppointmentConfirmedDialogProps } from './dialogs/AppointmentConfirmedDialog';
export { AppointmentCanceledDialog } from './dialogs/AppointmentCanceledDialog';
export type { AppointmentCanceledDialogProps } from './dialogs/AppointmentCanceledDialog';
export { ReservationCanceledDialog } from './dialogs/ReservationCanceledDialog';
export type { ReservationCanceledDialogProps } from './dialogs/ReservationCanceledDialog';
export { AppointmentSuccessDialog } from './dialogs/AppointmentSuccessDialog';
export type { AppointmentSuccessDialogProps } from './dialogs/AppointmentSuccessDialog';
export { CancelAppointmentDialog } from './dialogs/CancelAppointmentDialog';
export type { CancelAppointmentDialogProps } from './dialogs/CancelAppointmentDialog';
export { ConfirmationDialog } from './dialogs/ConfirmationDialog';
export type { ConfirmationDialogProps } from './dialogs/ConfirmationDialog.types';
export { ContentDialog } from './dialogs/ContentDialog';
export type {
  ContentDialogProps,
  ContentDialogAction,
  ContentDialogActionVariant,
} from './dialogs/ContentDialog';
export { MessageOkDialog } from './dialogs/MessageOkDialog';
export type { MessageOkDialogProps } from './dialogs/MessageOkDialog';
export { OkDialog } from './dialogs/OkDialog';
export type { OkDialogProps } from './dialogs/OkDialog';
export { UnitReservedDialog } from './dialogs/UnitReservedDialog';
export type { UnitReservedDialogProps } from './dialogs/UnitReservedDialog';
export { SuccessDialog } from './dialogs/SuccessDialog';
export { ServiceRequestSuccessDialog } from './dialogs/ServiceRequestSuccessDialog';
export type { ServiceRequestSuccessDialogProps } from './dialogs/ServiceRequestSuccessDialog';
export { SelectionChip } from './SelectionChip';
export type { SelectionChipProps } from './SelectionChip';

// Loaders
export { FullScreenLoader } from './FullScreenLoader';
export type { FullScreenLoaderProps } from './FullScreenLoader';
export { FormPicker } from './FormPicker';
export type { FormPickerProps, FormPickerOption } from './FormPicker';
export { OptionPickerModal } from './OptionPickerModal';
export type { OptionPickerModalProps } from './OptionPickerModal';
export { LayoutToggle } from './LayoutToggle';
export type { LayoutToggleProps, LayoutType } from './LayoutToggle';

